import React from 'react'
import PropTypes from 'prop-types'
import CheckedInStatus from '../CheckedInStatus'
import CheckedInPrompt from '../CheckOutPrompt'

class CheckedIn extends React.Component {
  state = {
    checkOutRequested: false,
  }

  setCheckOutRequestState = () => {
    this.setState({
      checkOutRequested: !this.state.checkOutRequested,
    })
  }

  checkOutPassenger = () => {
    const { passengerId, flightId, checkOutPassenger } = this.props

    checkOutPassenger({
      passengerId,
      flightId,
    })
  }

  render() {
    const { classes, rowId } = this.props

    return (
      <span className={classes.checkedInStatus}>
        {this.state.checkOutRequested ? (
          <CheckedInPrompt
            onCancel={this.setCheckOutRequestState}
            onConfirm={this.checkOutPassenger}
            dataElement={`${rowId}-check-in-prompt`}
          />
        ) : (
          <CheckedInStatus
          onCheckedInClicked={this.setCheckOutRequestState}
          dataElement={`${rowId}-check-in-status`} />
        )}
      </span>
    )
  }
}

CheckedIn.propTypes = {
  classes: PropTypes.shape({
    checkedInStatus: PropTypes.string,
  }),
  passengerId: PropTypes.string,
  flightId: PropTypes.string,
  checkOutPassenger: PropTypes.func,
  rowId: PropTypes.number,
}

export default CheckedIn
